import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { conferences } from '../api';
import Navbar from '../components/Navbar';

const Dashboard = () => {
  const [conferenceList, setConferenceList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    conferences.getAll()
      .then((res) => setConferenceList(res.data))
      .catch(() => setError('Kunne ikke hente konferanser'))
      .finally(() => setLoading(false));
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Er du sikker på at du vil slette denne konferansen?')) return;
    try {
      await conferences.delete(id);
      setConferenceList(conferenceList.filter((c) => c.id !== id));
    } catch {
      setError('Kunne ikke slette konferansen');
    }
  };

  return (
    <div className="min-h-screen bg-cream-50 dark:bg-dark-200">
      <Navbar />

      <div className="max-w-5xl mx-auto p-6">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h2 className="text-2xl font-bold text-navy-800 dark:text-cream-100">Mine konferanser</h2>
            <p className="text-navy-400 dark:text-cream-200 text-sm mt-1">Administrer dine arrangementer</p>
          </div>
          <button
            onClick={() => navigate('/conference/new')}
            className="btn-primary flex items-center gap-2"
          >
            + Ny konferanse
          </button>
        </div>

        {error && (
          <div className="bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 p-4 rounded-xl mb-6 text-sm border border-red-200 dark:border-red-800">
            {error}
          </div>
        )}

        {loading ? (
          <div className="flex items-center justify-center py-20">
            <p className="text-navy-400 dark:text-cream-200">Laster...</p>
          </div>
        ) : conferenceList.length === 0 ? (
          <div className="card dark:bg-dark-50 dark:border-dark-100 text-center py-16">
            <p className="text-4xl mb-4">🎤</p>
            <p className="text-navy-600 dark:text-cream-200 font-medium mb-2">Ingen konferanser ennå</p>
            <p className="text-navy-400 dark:text-cream-200 text-sm mb-6">Kom i gang ved å opprette din første konferanse</p>
            <button
              onClick={() => navigate('/conference/new')}
              className="btn-primary"
            >
              Opprett konferanse
            </button>
          </div>
        ) : (
          <div className="grid gap-4">
            {conferenceList.map((conference) => (
              <div
                key={conference.id}
               className="card dark:bg-dark-50 dark:border-dark-100 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200"
              >
                <div className="flex justify-between items-center">
                  <div className="cursor-pointer flex-1" onClick={() => navigate(`/conference/${conference.id}`)}>
                    {conference.organizer && (
                      <p className="text-gold-600 dark:text-gold-400 text-xs font-semibold uppercase tracking-wide mb-1">
                        {conference.organizer}
                      </p>
                    )}
                    <h3 className="text-lg font-bold text-navy-800 dark:text-cream-100">{conference.title}</h3>
                    <p className="text-navy-500 dark:text-cream-200 text-sm mt-0.5">
                      {new Date(conference.date).toLocaleDateString('nb-NO', { day: 'numeric', month: 'long', year: 'numeric' })}
                      {conference.end_date && ` - ${new Date(conference.end_date).toLocaleDateString('nb-NO', { day: 'numeric', month: 'long', year: 'numeric' })}`}
                      {conference.location && ` · ${conference.location}`}
                    </p>
			 <p className="text-navy-400 dark:text-navy-400 text-xs mt-1">
  {conference.presentation_count > 0
    ? `${conference.presentation_count} presentasjon${conference.presentation_count !== '1' ? 'er' : ''}`
    : 'Ingen presentasjoner ennå'}
</p>
                  </div>
                  <div className="flex gap-2 ml-4">
                    <button
                      onClick={() => navigate(`/conference/${conference.id}`)}
                      className="btn-primary text-sm"
                    >
                      Åpne
                    </button>
                    <button
                      onClick={() => handleDelete(conference.id)}
                      className="bg-red-50 dark:bg-red-900/20 text-red-500 dark:text-red-400 px-3 py-2 rounded-lg text-sm hover:bg-red-100 dark:hover:bg-red-900/40 transition-all"
                    >
                      Slett
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
